import InputNumber from './src/index.vue'

export default InputNumber
